export enum NavType {
  Portfolio = 'Portfolio',
  Loyalty = 'Loyalty',
  ServiceToSales = 'Service-to-Sales',
  Service = 'Service',
  Acquire = 'Acquire',
  Turn = 'Turn',
  DigitalAudience = 'Digital Audience',
  ReportingPrivateIncentive = 'Private Incentive Insights',
  Reporting = 'Performance Insights',
  StoreSettings = 'Store Settings',
  PrivateIncentiveLookup = 'Private Incentive Lookup',
  MarketImpact = 'Market Impact',
  MarketImpactNew = 'Market Impact: New',
  MarketImpactUsed = 'Market Impact: Used',
  MarketImpactSummary = 'Market Impact Summary',
  Recent = 'Recent',
  Favorites = 'Favorites',
  YourProfile = 'Your-Profile',
  Support = 'Support',
  LogOut = 'LogOut',
  GetMobileApp = 'Get-Mobile-App',
}
